import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { get as getStateDatas, save as saveStateDatas } from 'store/member/state-data'
import { useEffect } from 'react'
import StaffFormUsNj from './Forms/us/nj/staff-form'
import StudentFormUsNj from './Forms/us/nj/student-form'
import EmptyForm from './Forms/empty'
import { getLanguages, getStateDataType } from 'store/lookup'
import { useMember } from 'components/Providers'
import { Box, Drawer, Grid } from '@mui/material'
import PersonalInfoCard from './PersonalInfoCard'
import SPEDInfoCard from './SPEDInfoCard'
import ELLInfoCard from './ELLInfoCard'
import StaffCard from './StaffCard'

export default function StateData() {
  const { memberId, employmentType, part } = useParams()
  const navigate = useNavigate()
  const member = useMember()
  const dispatch = useDispatch()
  const languages = useSelector(state => state.lookup.languages)
  const { country, state } = useSelector(state => state.session.campus?.address)
  const employmentStateDataType = useSelector(state => state.lookup.stateDataType)?.filter(
    item => item.type === employmentType,
  )

  const basePath = `/member/${member.person.type}/${member.id}/state-data`

  const sharedStateDataType = useSelector(state => state.lookup.stateDataType)?.filter(item => item.type === 'shared')

  useEffect(() => {
    member?.stateData || dispatch(getStateDatas({ type: employmentType, memberId }))
  }, [member?.id])

  useEffect(() => {
    employmentStateDataType || dispatch(getStateDataType({ state: state.toLowerCase(), type: employmentType }))
    languages || dispatch(getLanguages())
  }, [])

  const saveForm = async data => {
    await dispatch(saveStateDatas({ type: employmentType, memberId, ...data }))
  }

  const getFormComponent = () => {
    const key = [country.toLowerCase(), state.toLowerCase(), employmentType].join('.')
    switch (key) {
      case 'us.nj.student':
        return StudentFormUsNj
      case 'us.nj.staff':
        return StaffFormUsNj
      default:
        return EmptyForm
    }
  }

  const StateDataForm = getFormComponent()

  if (!(country && state && member && employmentStateDataType && languages)) return null

  return (
    <Box sx={{ m: 2 }}>
      <Grid container spacing={2}>
        {member.person.type === 'staff' && (
          <Grid item xs={12} md={12}>
            <StaffCard member={member} employmentStateDataType={employmentStateDataType} languages={languages} />
          </Grid>
        )}
        {member.person.type !== 'staff' && (
          <>
            <Grid item xs={12} md={12}>
              <PersonalInfoCard
                member={member}
                employmentStateDataType={employmentStateDataType}
                languages={languages}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <ELLInfoCard
                member={member}
                employmentStateDataType={employmentStateDataType}
                sharedStateDataType={sharedStateDataType}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <SPEDInfoCard member={member} />
            </Grid>
          </>
        )}
      </Grid>
      <Drawer
        PaperProps={{
          sx: {
            width: 800,
          },
        }}
        open={Boolean(part)}
        anchor="right"
        onClose={() => navigate(`${basePath}`)}
      >
        <StateDataForm
          stateDataType={employmentStateDataType}
          sharedStateDataType={sharedStateDataType}
          saveForm={saveForm}
        />
      </Drawer>
    </Box>
  )
}
